module.exports = __webpack_public_path__ + "img/img11.24352a03.png";